import styled, { css } from 'styled-components';
import BlogPost from '../../../../shared/components/BlogPost';
import { Props as BlogPostProps } from '../../../../shared/components/BlogPost/BlogPost';
import Columns, { Column } from '../../../../shared/components/Columns';
import { CTALink } from '../../../../shared/components/Link';
import { blogLogoBranding } from '../../../../shared/lib/platformUrls';
import { media, spaces } from '../../../../shared/lib/styles';
import Box from '../../../../shared/spa/core-components/Box';

// TODO: Figure out if that's share-worthy
const Text = styled.div<{ narrow?: boolean }>`
    ${({ narrow }) =>
        narrow &&
        css`
            max-width: 32em;

            @media ${media('small')} {
                max-width: none;
            }
        `}
`;

const TopCTALink = styled(CTALink)`
    @media ${media('small', 'medium')} {
        display: none;
    }
`;

const BottomCTALink = styled(CTALink)`
    margin-top: ${spaces.space6}px;
    align-self: flex-end;

    @media ${media('normal', 'large')} {
        display: none;
        margin-top: 0;
    }
`;

interface Props {
    blogPosts: BlogPostProps[];
}

export default function RelatedBlogPosts({ blogPosts }: Props) {
    return (
        <>
            <Box
                paddingBottom={'space10'}
                paddingTop={'space10'}
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'flex-end'}
            >
                <Text narrow>
                    {__(
                        'We thought you might like these great ideas and tips on building a brand and running a successful business.'
                    )}
                </Text>
                <TopCTALink href={'/blog/logo-branding/'} color="grey800">
                    {__('See more logo and branding ideas')}
                </TopCTALink>
            </Box>
            <Box display="inline-flex" flexDirection="column">
                <Columns>
                    {blogPosts.map((blogPost, index) => (
                        <Column key={index} width={[12, 12, 4, 4]}>
                            <Box paddingBottom="space7">
                                <BlogPost
                                    thumbnailUrl={blogPost.thumbnailUrl}
                                    channel={blogPost.channel}
                                    title={blogPost.title}
                                    url={blogPost.url}
                                    readTimeMinutes={blogPost.readTimeMinutes}
                                />
                            </Box>
                        </Column>
                    ))}
                </Columns>
                <BottomCTALink href={blogLogoBranding()} color="grey800">
                    {__('See more logo and branding ideas')}
                </BottomCTALink>
            </Box>
        </>
    );
}
